import { Navigate, useLocation } from "react-router-dom";
import Layout from "../../Components/Pages/Layout/Layout";
import { TOKENS } from "../Constants/Constants";
import { GetSessionStorageData } from "../../Services/Helpers/Helper";
import { ProSidebarProvider } from "react-pro-sidebar";
import { useEffect } from "react";
import Registration from "../../Components/Authentication/Registration/Registration";

const PrivateRoutesCheck = () => {
  const token = GetSessionStorageData(TOKENS.ACCESS_TOKEN);

  return token ? (
    <>
      <ProSidebarProvider>
        <Layout />
      </ProSidebarProvider>
    </>
  ) : (
    <>
      <Navigate to="/login" />
    </>
  );
};

export default PrivateRoutesCheck;
